// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAqU_kpxTrTdNbD4oIFEDsXq4GcI0oqesY",
  authDomain: "fogareiro-15ea4.firebaseapp.com",
  projectId: "fogareiro-15ea4",
  storageBucket: "fogareiro-15ea4.firebasestorage.app",
  messagingSenderId: "352839520527",
  appId: "1:352839520527:web:6684fb20129268e6832e7a",
  measurementId: "G-6603D2RTGG"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);